import { render, staticRenderFns } from "./TabsLandscape.vue?vue&type=template&id=f9fe2e58&"
import script from "./TabsLandscape.vue?vue&type=script&lang=ts&"
export * from "./TabsLandscape.vue?vue&type=script&lang=ts&"
import style0 from "./TabsLandscape.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports